import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

async function fetchAllCastScreens(module, payload = {}) {
  const api = useApiStore();
  const { dispatch } = module;
  const opts = payload.opts ?? {};
  const config = Object.assign(
    getDefaultOpts(),
    {
      isCms: false,
      isAuth: false,
    },
    opts
  );

  const { data: castScreens } = await dispatch("httpRequest", {
    func: api.fetchAllScreens(),
    config,
  });

  dispatch(
    "setSettingsVar",
    {
      key: "castScreens",
      value: castScreens,
    },
    { root: true }
  );
}

export { fetchAllCastScreens };
